import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { RealFiatAssets } from '@libs/types';
import { CurrencyType } from 'src/constants';

export type GetAssetAvgBuyPriceResponse = {
  getAssetAvgBuyPrice: number;
};
export type GetAssetAvgBuyPriceArgs = {
  code?: CurrencyType; // NOTE: IT SHOULD BE MANDATORY
  valueAssetCode: RealFiatAssets;
};

export const getAssetAvgBuyPriceQuery: TypedDocumentNode<
  DefaultApiResponse<GetAssetAvgBuyPriceResponse>,
  DefaultArg<GetAssetAvgBuyPriceArgs>
> = gql`
  query GetAssetAvgBuyPrice($record: GetAssetAvgBuyPriceRecord!) {
    getAssetAvgBuyPrice(record: $record)
  }
`;
